<template>
  <Modal
    title="Documentos"
    :active.sync="activePopUp"
    id="popup-documents"
    @close="closeModal"
  >
    <div class="flex flex-row w-full mb-4">
      <div class="w-8/12">
        <span class="text-xl">{{ policyOrEndorsementLabel }}</span>
      </div>
      <div class="w-2/12">
        <vs-button
          v-if="permissionRegeneratePDFs && isPolicy"
          radius
          v-tooltip="'Regerar'"
          color="warning"
          icon-pack="feather"
          icon="icon-refresh-cw"
          class="d-inline"
          @click="
            regeneratePDF(
              pdfs.insurancePolicy.contract,
              pdfs.insurancePolicy.type,
            )
          "
        ></vs-button>
      </div>
      <div v-if="pdfs.insurancePolicy.link" class="w-2/12">
        <vs-button
          radius
          v-tooltip="'Ver'"
          color="primary"
          icon-pack="feather"
          icon="icon-file"
          class="d-inline"
          @click="openPDF(pdfs.insurancePolicy.link)"
        ></vs-button>
      </div>
    </div>
    <div class="flex flex-row w-full mb-4">
      <div class="w-8/12"><span class="text-xl">Proposta</span></div>
      <div class="w-2/12">
        <vs-button
          v-if="permissionRegeneratePDFs && isProposal && !isPolicy"
          radius
          v-tooltip="'Regerar'"
          color="warning"
          icon-pack="feather"
          icon="icon-refresh-cw"
          class="d-inline"
          @click="
            regeneratePDF(
              pdfs.insuranceProposal.contract,
              pdfs.insuranceProposal.type,
            )
          "
        ></vs-button>
      </div>
      <div v-if="pdfs.insuranceProposal.link" class="w-2/12">
        <vs-button
          radius
          v-tooltip="'Ver'"
          color="primary"
          icon-pack="feather"
          icon="icon-file"
          class="d-inline"
          @click="openPDF(pdfs.insuranceProposal.link)"
        ></vs-button>
      </div>
    </div>
    <div class="flex flex-row w-full mb-4">
      <div class="w-8/12"><span class="text-xl">Cotação</span></div>
      <div class="w-2/12">
        <vs-button
          v-if="permissionRegeneratePDFs"
          radius
          v-tooltip="'Regerar'"
          color="warning"
          icon-pack="feather"
          icon="icon-refresh-cw"
          class="d-inline"
          @click="
            regeneratePDF(
              pdfs.insuranceQuotation.contract,
              pdfs.insuranceQuotation.type,
            )
          "
        ></vs-button>
      </div>
      <div v-if="pdfs.insuranceQuotation.link" class="w-2/12">
        <vs-button
          radius
          v-tooltip="'Ver'"
          color="primary"
          icon-pack="feather"
          icon="icon-file"
          class="d-inline"
          @click="openPDF(pdfs.insuranceQuotation.link)"
        ></vs-button>
      </div>
    </div>
  </Modal>
</template>
<script>
import pdfApi from '../../services/pdf.api';
import { ContractPdfEnum, TypeSavePdf } from '../../utils/constants';

import notify from '../../utils/notify';
import Modal from '../../components/Modal.vue';

export default {
  name: 'ModalDocumentos',
  props: [
    'chave',
    'active',
    'insuranceQuotation',
    'insuranceProposal',
    'insurancePolicy',
    'proposalDate',
    'accessionDate',
    'isNewPolicy',
  ],
  components: {
    Modal,
  },
  data() {
    return {
      activePopUp: false,
      pdfs: {
        insuranceQuotation: {
          link: null,
          contract: null,
          type: TypeSavePdf.QUOTATION,
        },
        insuranceProposal: {
          link: null,
          contract: null,
          type: TypeSavePdf.PROPOSAL,
        },
        insurancePolicy: {
          link: null,
          contract: null,
          type: TypeSavePdf.POLICY,
        },
      },
    };
  },
  computed: {
    permissionRegeneratePDFs() {
      return this.$can('Regerar PDFs', 'Vistorias');
    },
    isProposal() {
      return Boolean(this.proposalDate);
    },
    isPolicy() {
      return Boolean(this.accessionDate);
    },
    policyOrEndorsementLabel() {
      return this.isNewPolicy ? 'Apólice' : 'Endosso';
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.open();
      }
    },
    isNewPolicy: {
      immediate: true,
      handler(val) {
        this.pdfs.insuranceQuotation.contract = val
          ? ContractPdfEnum.QUOTATION_AUTO
          : ContractPdfEnum.AUTO_QUOTATION_ENDORSEMENT;
        this.pdfs.insuranceProposal.contract = val
          ? ContractPdfEnum.AUTO
          : ContractPdfEnum.AUTO_PROPOSAL_ENDORSEMENT;
        this.pdfs.insurancePolicy.contract = val
          ? ContractPdfEnum.AUTO
          : ContractPdfEnum.AUTO_POLICY_ENDORSEMENT;
      },
    },
    insuranceQuotation: {
      immediate: true,
      handler(val) {
        this.pdfs.insuranceQuotation.link = val;
      },
    },
    insuranceProposal: {
      immediate: true,
      handler(val) {
        this.pdfs.insuranceProposal.link = val;
      },
    },
    insurancePolicy: {
      immediate: true,
      handler(val) {
        this.pdfs.insurancePolicy.link = val;
      },
    },
  },
  methods: {
    async open() {
      this.pdfs.insuranceQuotation.link = this.insuranceQuotation;
      this.pdfs.insuranceProposal.link = this.insuranceProposal;
      this.pdfs.insurancePolicy.link = this.insurancePolicy;
      this.activePopUp = true;
    },
    closeModal() {
      this.activePopUp = false;
      this.$emit('close', { ...this.pdfs });
    },
    async regeneratePDF(contractPDF, typePDF) {
      try {
        this.$vs.loading();

        const link = await pdfApi.regenerate(this.chave, contractPDF, typePDF);
        if (typePDF === TypeSavePdf.QUOTATION) {
          this.pdfs.insuranceQuotation.link = link;
        }

        if (typePDF === TypeSavePdf.PROPOSAL) {
          this.pdfs.insuranceProposal.link = link;
        }

        if (typePDF === TypeSavePdf.POLICY) {
          this.pdfs.insurancePolicy.link = link;
        }

        notify.notifySuccess(this.$vs, 'PDF regerado com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao regerar PDF.');
      } finally {
        this.$vs.loading.close();
      }
    },
    openPDF(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
<style>
#popup-documents.con-vs-popup .vs-popup {
  width: 25rem;
}
</style>
